<template>
  <div class="main-page">
    <Sidebar/>
    <div class="content">
      <router-view/>
    </div>
  </div>
</template>

<script>
import Sidebar from './Sidebar.vue';

export default {
  name: 'MainPage',
  components: {
    Sidebar
  }
};
</script>

<style scoped>

.main-page {
  display: flex;
}

.content {
  flex: 1;
}
</style>
